<template>
    <div
        :for="id"
        class="radio-button"
        :class="{ 'radio-button--active': value === inputValue }"
    >
        <label class="radio-button-container">
            <slot name="label">
                <span class="emphasize">{{ label }}</span>
            </slot>
            <input
                :id="id"
                :dusk="id"
                type="radio"
                :value="inputValue"
                :checked="value === inputValue"
                @input="$emit('input', inputValue)"
            />
            <span class="custom-radio-checkmark"></span>
        </label>
    </div>
</template>

<script>
export default {
    name: "RadioButton",
    props: {
        id: { type: String, required: true },
        label: { type: String },
        inputValue: {},
        value: {}
    }
};
</script>
